<template>
  <div class="c-slideInOverlay" :class="[{ 'is-open': isOpen }, { 'is-closed': !isOpen }]">
    <transition name="fade">
      <div class="c-slideInOverlay__background" @click="close" v-if="isOpen"></div>
    </transition>
    <div class="c-slideInOverlay__slidein" :class="placementClass">
      <div class="inner">
        <div class="inner__header">
          <slot name="header"></slot>
        </div>
        <div class="inner__body">
          <slot name="body"></slot>
        </div>
        <div class="inner__footer">
          <slot name="footer"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SlideInOverlay",
  components: {},

  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },

    placement: {
      type: String,
      default: "right",
    },
  },

  computed: {
    placementClass() {
      return "c-slideInOverlay__slidein--" + this.placement;
    },
  },

  methods: {
    close() {
      this.$emit("close");
    },
  },
};
</script>

<style lang="scss">
@import "@/scss/abstracts/variables.scss";
@import "../../scss/base/nitty.scss";

.c-slideInOverlay {
  position: relative;

  &__background {
    bottom: 0;
    left: 0;
    position: fixed;
    right: 0;
    top: 0;
    opacity: 0;
    width: 100%;
    z-index: 20;
  }

  &__slidein {
    position: relative;
    transition: $t-nice;
    display: flex;
    max-height: 100%;
    position: fixed;
    z-index: 20;
    top: 0;
    bottom: 0;
    right: 0;
    opacity: 0;
    width: 100%;
    max-width: 414px;
    background-color: $c-white;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
    transition: transform 500ms $t-nice, opacity 300ms $t-nice;

    &--left {
      left: 0;
      transform: translate(-100%, 0);
    }

    &--right {
      right: 0;
      transform: translate(100%, 0);
    }

    .is-open & {
      opacity: 1;
      transform: translate(0, 0);
    }

    .inner {
      width: 100%;

      &__body {
        position: relative;
        overflow-y: auto;
      }

      &__footer {
        width: 100%;
        position: fixed;
        bottom: 0;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }

  &.is-open {
    .c-slideInOverlay__inner {
      opacity: 1;
      transform: translate(0, 0);
    }
  }
}
</style>